import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { SectionTitle } from "@/components/dashboard/widgets";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function Creatives() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/affiliate/creatives").then(r => setRows(r.data)); }, []);
  return (
    <div className="space-y-6">
      <SectionTitle title="Creatives library" subtitle="Banners, email templates, scripts and case studies." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {rows.map((c) => (
          <Card key={c.id} className="rounded-xl shadow-soft border-slate-200">
            <CardContent className="p-5">
              <div className="rounded-lg bg-slate-100 border border-slate-200 aspect-[16/9] grid place-items-center text-slate-400 text-xs font-mono">{c.type.toUpperCase()} · {c.size}</div>
              <div className="mt-4 font-medium text-slate-900">{c.name}</div>
              <div className="text-xs text-slate-500 mt-0.5">Type · {c.type}</div>
              <Button variant="outline" size="sm" className="mt-4 rounded-full"><Download className="size-4" /> Download</Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
